// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"b352742c","231":"b352742c","256":"b352742c"}[chunkId] + ".chunk.css";
};